const PATTERN = /(https?:\/\/[^\s]+|www\.[^\s]+|[\w.+-]+@[\w-]+(?:\.[\w-]+)+|\+?\d[\d\s()-]{7,}\d)/g;

function hrefFor(token) {
  if (token.includes("@") && !token.startsWith("http")) return `mailto:${token}`;
  if (/^https?:\/\//.test(token)) return token;
  if (token.startsWith("www.")) return `https://${token}`;
  return `tel:${token.replace(/[^\d+]/g, "")}`;
}

export const Linkify = ({ text, className = "" }) => {
  const parts = String(text || "").split(PATTERN);
  return (
    <p className={`whitespace-pre-wrap break-words ${className}`}>
      {parts.map((part, i) => {
        if (i % 2 === 0) return part;
        const trail = part.match(/[.,;:)]+$/)?.[0] || "";
        const token = trail ? part.slice(0, -trail.length) : part;
        const external = /^(https?:|www\.)/.test(token);
        return (
          <span key={i}>
            <a
              href={hrefFor(token)}
              className="font-medium underline decoration-1 underline-offset-4 hover:opacity-80"
              {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
            >
              {token}
            </a>
            {trail}
          </span>
        );
      })}
    </p>
  );
};
